import {Button, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Input, Label,} from '@tinct/web-components';
import {useForm} from 'react-hook-form';
import {ApiError, useValidateAudience} from '@tinct/core-api';
import {handleApiError} from "@tinct/web-form";

type CreateAudienceFormValues = {
  name: string;
};

export type CreateAudienceStepProps = {
  onCancel: () => void;
  onCreateAudience: (name: string) => void;
};

export const CreateAudienceStep = ({
  onCancel,
  onCreateAudience,
}: CreateAudienceStepProps) => {
  const form = useForm<CreateAudienceFormValues>({
    defaultValues: {
      name: '',
    },
    mode: 'onChange',
  });
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = form

  const { mutateAsync: validateAudience, isPending: isValidating } =
    useValidateAudience();

  const onSubmit = async (data: CreateAudienceFormValues) => {
    try {
      await validateAudience({ data: { name: data.name }, group: 'create' });
      onCreateAudience(data.name);
    } catch (error) {
      handleApiError(error as ApiError, form);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-6">
      <DialogHeader>
        <DialogTitle>Create new audience</DialogTitle>
        <DialogDescription>
          Give your audience a name to get started
        </DialogDescription>
      </DialogHeader>

      <div>
        <Label htmlFor="name">Audience name</Label>
        <Input
          id="name"
          placeholder="e.g. Q4 Europe Tech scale-up"
          className="mt-2"
          {...register('name', {
            required: 'Name is required',
            minLength: {
              value: 2,
              message: 'Name must be at least 2 characters',
            },
            maxLength: {
              value: 250,
              message: 'Name must not exceed 250 characters',
            },
          })}
        />
        {errors.name && (
          <p className="text-sm text-destructive mt-1">{errors.name.message}</p>
        )}
      </div>

      <DialogFooter className="sm:justify-between">
        <Button type="button" variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" disabled={!isValid || isValidating}>
          Create & add companies
        </Button>
      </DialogFooter>
    </form>
  );
};
